import React from 'react';
import PropTypes from 'prop-types';
import { ruleType } from 'types';
import Tooltip from '@omilia/tooltip';
import _get from 'lodash/get';

import InspectTabs from 'components/InspectTabs';

import './style.scss';

const RulesInspectTabs = ({
  rule,
  selectedTabIndex,
  icon,
  tabs,
  closeTabs,
  changeTab,
}) => (
  <InspectTabs
    item={rule}
    tabs={tabs}
    icon={icon}
    selectedTabIndex={selectedTabIndex}
    changeTab={changeTab}
    closeTabs={closeTabs}
    rightOptions={
      _get(rule, 'actions.length', 0) > 0 &&
      _get(rule, 'matching_pattern_elements.length', 0) > 0 ? null : (
        <Tooltip
          placement="left"
          content={
            <React.Fragment>
              Complete
              <br />
              configuration
              <br />
              to use this
              <br />
              rule!
            </React.Fragment>
          }
        >
          <div styleName="warning">
            <span className="icon-warning" />
          </div>
        </Tooltip>
      )
    }
  />
);

RulesInspectTabs.propTypes = {
  rule: ruleType,
  selectedTabIndex: PropTypes.number,
  icon: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.object),
  closeTabs: PropTypes.func,
  changeTab: PropTypes.func,
};

export default RulesInspectTabs;
